import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const BSC_TOKEN_TICKERS = [Ticker.USDC, Ticker.USDT, Ticker.DOGE, Ticker.SHIB, Ticker.ETH]

export type BscTokenTicker = IterableElement<typeof BSC_TOKEN_TICKERS>
